import React from 'react';
import moment from 'moment';
import debounce from 'debounce';

import Search from '../../explore/search'

import {
    Card,
    DatePicker,
    Row,
    Col,
    Button,
    Modal,
    InputNumber,
} from 'antd';

import { URL_ENDPOINT } from '../../../index';

const { RangePicker } = DatePicker


class Finance extends React.Component { 

    constructor(props) {
        super(props)
        this.state = {
            supplierName: false,
            startDate: moment().startOf('month'),
            endDate: moment(),
            commission: 0.0
        }
        this.onCommissionChange = debounce(this.onCommissionChange, 350)
    }

    render() {

        const colSpan = 4

        return(
            <Card
                title='Supplier SOA'>
                <Row>
                    <Col span={colSpan}>
                        Pick Date Range
                    </Col>
                    <Col span={24 - colSpan}>
                        <RangePicker
                            style={{ width: '50%' }}
                            onChange={(value) => this.onDateChange(value)}
                            value={[this.state.startDate,this.state.endDate]}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col span={colSpan}>
                        Select Supplier
                    </Col>
                    <Col span={24 - colSpan}>
                        <Search
                            onSelect={this.onSelect}
                            value={this.state.supplierName}
                            type="seller"
                        />
                    </Col>
                </Row>

                <Row>
                    <Col span={colSpan}>
                        Commission %
                    </Col>
                    <Col span={24 - colSpan}>
                        <InputNumber 
                            step={0.01}
                            min={0}
                            onChange={this.onCommissionChange}
                            />
                    </Col>
                </Row>

                <Row>
                    <Button
                        type='primary'
                        onClick={this.getSupplierSOA}>
                        Generate
                    </Button>
                </Row>


            </Card>
        )
    }

    componentDidMount() {

    }

    getSupplierSOA = () => {

        const {startDate, endDate, supplierName, commission} = this.state;
        if (!supplierName) {
            return Modal.error({
                centered: true,
                title: "Error",
                content: "Please Select a supplier"
            })
        }

        window.open(`${URL_ENDPOINT}/api/admin/finance/supplier-soa?supplierName=${encodeURIComponent(supplierName)}&commission=${commission}&startDate=${startDate.unix()}&endDate=${endDate.unix()}`,"_self")

    }

    onSelect = (value) => {

        this.setState({
            supplierName: value
        })

    }

    onCommissionChange = (value) => {
        this.setState({
            commission: value
        })
    }

    onDateChange = (value) => {
        this.setState({
            startDate: value[0],
            endDate: value[1]
        })
    }

}

export default Finance


// WEBPACK FOOTER //
// ./src/components/finance/soa/index.js